<template>
  <div class="block">
    <h2>{{ $t('customizeSettings') }}</h2>

      <div v-for="(option, key) in options" :key="key" class="unit">
        <config-option
            v-model.trim="configOptions[option.id]"
            :input="option"
            :payment-period="paymentPeriod"
            :currency-info="currencyInfo"
            :domain-type="domainType"
            :depends-on="getDependsOn(option.id)"
            @emitDependsOn="getAllDependsOn($event, key)"
            :is-wordpress-v3="isWordpressV3"
        />
      </div>
  </div>
</template>

<script>
  import { CART_MUTATIONS } from "@/store/modules/cart-context";
  import ConfigOption from '@/shared/components/CustomFields/ConfigOption.vue';

  export default {
    name: "ExtraOptions",
    components: {
      ConfigOption,
    },
    props: {
      currencyInfo: { type: [Object, Array], default: () => ({}) },
      configOpt: { type: [Object, Array], default: () => ([]) },
      paymentPeriod: { type: [Object, Array], default: () => ({}) },
      domainType: { type: String },
      isWordpressV3: { type: Boolean, default: false },
    },
    data: () => ({
      configOptions: {},
      allDependsOn: [],
      computedDependsOn: [],
    }),
    computed: {
      options() {
        const options = [];
        Object.values(this.configOpt).forEach(group => options.push(...group.options));
        return options;
      },
    },
    methods: {
      getAllDependsOn(arr, currentKey) {
        this.computedDependsOn = [];
        this.allDependsOn[currentKey] = arr;
        Object.values(this.allDependsOn).forEach(item => {
          if(item && item.length > 0) { this.computedDependsOn.push(...item) }
        });
      },
      getDependsOn(id) {
        const currentDependsOn = this.computedDependsOn.find(item => item.option_id === id);
        return currentDependsOn ? currentDependsOn.values_ids : [];
      }
    },
    watch: {
      configOptions: {
        handler() {
          this.$store.commit(`cartContext/${CART_MUTATIONS.SET_CART_CONTEXT}`, { configOpts: this.configOptions });
        },
        deep: true,
      },
      configOpt: {
        handler(val) {
          const configOptions = !val || val.length <= 0 ? {} : this.configOptions;
          this.$store.commit(`cartContext/${CART_MUTATIONS.SET_CART_CONTEXT}`, { configOpts: configOptions });
        },
        deep: true,
      },
    }
  }
</script>
